    angular.module('qkr.department')
        .config(configDepartment);

    configDepartment.$inject = ['$routeSegmentProvider'];

    function configDepartment($routeSegmentProvider) {
        const resolve = {
            departments(departmentService, $routeParams, appConfig, $q) {
                'ngInject';
                const isSupplier = (appConfig.businessCategory === 'Supplier');
                const departments = departmentService.getDepartments($routeParams.outletId);

                return isSupplier ?
                    $q.all([departments, departmentService.loadPendingRequests()])
                        .then(([departments, pendingRequests]) =>
                            departmentService.addNewAttributesToDepartment(departments, pendingRequests.data))
                    : departments;
            },
            paymentConfigList(paymentgatewayService) {
                'ngInject';
                return paymentgatewayService.loadPaymentSettingsList()
                    .then(response => response.data);
            }
        };

        $routeSegmentProvider
            .when('/departments/:outletId', 'departments', { pageTitle: 'Menus' })
            .when('/department-management/:outletId', 'department-management', { pageTitle: 'Manage Departments' });

        $routeSegmentProvider
            .segment('department-management', {
                controller: 'departmentManagementController',
                template: require('../templates/listDepartment.html'),
                resolve,
                dependencies: ['outletId'],
                untilResolved: {
                    template: require('../../shared/loading-screen.html')
                },
                resolveFailed: {
                    template: require('../../shared/loading-error.html')
                }
            })
            .segment('departments', {
                controller: 'departmentController',
                template: require('../templates/departments.html'),
                resolve,
                dependencies: ['outletId'],
                untilResolved: {
                    template: require('../../shared/loading-screen.html')
                },
                resolveFailed: {
                    template: require('../../shared/loading-error.html')
                }
            });
    }



// WEBPACK FOOTER //
// ./src/department/config/department.config.js